export default () => ({
  slider_INPUT_MIN: {
  },
});
